define('home/mixins/withChannelAvatar',[
    'underscore',
], function (
    _
) {
    'use strict';

    // Return the mixin properties and functions with a closure around
    // the getChannel function, specified on a per-mixin basis
    function getWithChannelAvatar(getChannel) {
        return {
            templateHelpers: function () {
                var channel = getChannel.call(this);
                var bannerColor = channel && channel.get('bannerColor');
                var channelInitial = channel && channel.get('name') && channel.get('name').charAt(0);

                return {
                    channel: channel && channel.toJSON(),
                    channelAvatar: channel && (channel.get('avatar') || channel.get('options').favicon),
                    bannerColorClass: bannerColor ? '-' + bannerColor : '',
                    channelInitial: channelInitial,
                };
            },
        };
    }

    /**
     * Mixes in the core channel following functionality, and the home-specific
     * follow tooltip.
     */
    function withChannelAvatar(_getChannel) {

        // A function to get the channel model for this view. If a special getter
        // is not given, channel is assumed to be the view's model.
        // This is passed to all the ChannelFollowTooltipWrapper functions that
        // require the channel model.
        var getChannel = _getChannel || function () {
            return this.model;
        };

        var withChannelAvatarMixin = getWithChannelAvatar(getChannel);

        this.templateHelpers = _.wrap(this.templateHelpers, function (_templateHelpers) {
            var data = _.isFunction(_templateHelpers) ? _templateHelpers.call(this) : _templateHelpers;

            return _.extend(withChannelAvatarMixin.templateHelpers.call(this), data);
        });
    }

    return withChannelAvatar;
});

